import qs from 'qs'
import { useParams } from 'react-router-dom'
import type { Params } from '../packages/blueprint-components/src/useTableHooks'
import { transformSelectComponentFilters } from '../util/transformSelectComponentFilters'
import type { EntityId } from '../types/constants'

interface useExportCsvProps {
    profile: EntityId | null
    params: Params
    endpoint: string
}

interface useExportCsvReturn {
    csvUrl: string
}

export const useExportCsv = ({
    profile,
    params,
    endpoint,
}: useExportCsvProps): useExportCsvReturn => {
    const urlParams = useParams()
    const exportCsvUrl = '/api/v5/export/csv?'

    const generateExportURL = (): string => {
        let output = exportCsvUrl

        const keys = [
            'campaign_id',
            'ad_group_id',
            'keyword_id',
            'target_id',
            'product_ad_id',
            'ad_id',
        ]
        const extra: { [key: string | number]: any } = {}
        keys.forEach((k) => {
            if (urlParams[k]) {
                extra[k] = urlParams[k]
            }
        })

        const transformedParams = transformSelectComponentFilters(params)
        output +=
            '&' +
            qs.stringify({
                ...transformedParams,
                ...extra,
                table: endpoint,
                profileId: profile,
            })

        return output
    }

    return {
        csvUrl: generateExportURL(),
    }
}
